onReady(($) => {
    const heroModules = $('.consolidated-hero-container')

    if (heroModules.length === 0) {
        return
    }
    // Ensure the wistia queue exists
    window._wq = window._wq || []

    const loadVideo = (heroModule) => {
        heroModule.classList.add('video-loaded')

        // Load the wistia video
        const videoId = $('.wistia_embed', heroModule)
            .data('video-id')
        loadWistiaMedia(videoId)

        loadWistiaLibrary()

        // Start the video once it's loaded
        _wq.push({
            id: videoId,
            onReady: (video) => $(`.wistia_async_${videoId} img`, heroModule)
                .click(),
        })
    }

    const utmQueryString = getUTMParameters()
    heroModules.each((i, heroModule) => {
        // Setup watch video button click interactions
        $('.cta-button.video', heroModule)
            .on('click', (e) => {
                if (!$("#video", heroModule)
                    .hasClass("video-active")) {
                    return
                }

                e.preventDefault()

                // This ensures the button's state resets
                setTimeout(() => e.target.blur(), 10)

                // Ensure the video is loaded
                if (!heroModule.classList.contains('video-loaded')) {
                    return loadVideo(heroModule)
                }

                $('img', heroModule)
                    .click()
            })

        // Replace or add UTMs on card CTAs
        if (utmQueryString) {
            $('.card a.cta-button', heroModule)
                .each((i, link) => replaceLinkParameters(link, utmQueryString))
        }
    })
    const consolidatedHeros = Array.from(document.querySelectorAll('.consolidated-hero'))
    for (const consolidatedHero of consolidatedHeros) {
        // Pauses slider animation until first slide has loaded
        const animatedImage = consolidatedHero.querySelector(".slider-container img:first-child")
        if (animatedImage && !animatedImage.complete) {
            animatedImage.addEventListener('load', () => animatedImage.parentNode.classList.add('play-animation'))
        }
        else {
            animatedImage && animatedImage.parentNode.classList.add('play-animation')
        }
        const ctaButtons = Array.from(consolidatedHero.querySelectorAll('.cta-button'))
        for (const ctaButton of ctaButtons) {
            ctaButton.addEventListener('click', (event) => submitCtaClickEvent(event, ctaButton, consolidatedHero))
        }
    }
})
